import { render, staticRenderFns } from "./ContractLand.vue?vue&type=template&id=0f9de32a&scoped=true&"
import script from "./ContractLand.vue?vue&type=script&lang=js&"
export * from "./ContractLand.vue?vue&type=script&lang=js&"
import style0 from "./ContractLand.vue?vue&type=style&index=0&id=0f9de32a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9de32a",
  null
  
)

export default component.exports